import { useQuery } from '@tanstack/react-query'
import { isApp } from '@zet/utils'
import { FIVE_MINUTES } from '@zet/utils/cacheTime'

import { fetchTier } from '../functions'

export function useTier() {
  return useQuery(['fetchTier'], fetchTier, {
    staleTime: FIVE_MINUTES,
    cacheTime: FIVE_MINUTES,
    enabled: isApp,
  })
}
